import { SCENARIO_STEP } from 'commonTypes/api/scenarios/BaseTypes';

export const autosendDisabledScenarios = [SCENARIO_STEP.CREDIT_SELECTION];
